import { MaxLengthValidator } from '@angular/forms';
import { CategoriesScores, FunctionalLocationNode } from './functional-location-hierarchy-scores-propagation.utils';

export class FunctionalLocationHierarchyScoresNormalizer {

  static normalizeNodeScores(currentNode: FunctionalLocationNode): void {
    if (currentNode?.Children?.length === 0  && currentNode?.NotReleasedWorkOrders?.length === 0 && currentNode?.ReleasedWorkOrders?.length === 0) return;
    
    this.normalizeScores(currentNode);
  }

  private static normalizeScores(currentNode: FunctionalLocationNode): void {
    if (currentNode.Id == "") {
      console.log("debug");
    }
    const maxChildrentScore = currentNode?.Children?.length > 0 ? Math.max(...currentNode.Children.map(c => c.Score)) : 0;
    const maxWorkorderScores = Math.max(currentNode?.ReleasedWorkOrders?.length > 0 ? Math.max(...currentNode.ReleasedWorkOrders.map(wo => wo.Score)) : 0,
      currentNode?.NotReleasedWorkOrders?.length > 0 ? Math.max(...currentNode.NotReleasedWorkOrders.map(wo => wo.Score)) : 0);
    
    const maxScore = Math.max(maxChildrentScore, maxWorkorderScores);

    if (maxScore > 0) {
      currentNode.ReleasedWorkOrders?.forEach(wo => {
        if (wo.WorkOrder.SAP_WorkOrderId == "114774862") {
          const debug = 1;
        }
        wo.Score = (wo.Score / maxScore) * 100.0;
      });

      currentNode.NotReleasedWorkOrders?.forEach(wo => {
        wo.Score = (wo.Score / maxScore) * 100.0;
      });
    }
    
    currentNode.Children?.forEach(child => {
      if (maxScore > 0) {
        child.Score = (child.Score / maxScore) * 100.0;
      } else {
        child.Score = 0.0;
      }
            
      this.normalizeNodeScores(child);
    });
  }
}
